module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAR9JREFUWEft1ksKgzAQgOEornoUtxI8TuvJao8jIVuP4kqkTCmltUnmkfhYxG2Q+Zl8oIU62VOcrEflIOxGkmxIa32DQcaYHhuInUcHtW1bz/NsYFBVVXoYhhEbGjqPCmqa5gKLUUrV7yEQo621kzQqNgiu6Loa3ltru92DwM2yLHfX4LIsO6kn0Ya+3MCVuZ5J6okd5HDjux2RJ0mQy40viu2JFRRy4yvieiIHEdz4mlieSEEMN9GeqEEcN1Ge0CCJmxhPwaAIN2JP3qAEbkSeQkEp3LA9OYNSuuF6+gvawA3L00/Qhm7IntZBW7ohefoE7eGG4ukVtKMb1FNxgJugJwg6wo0v6oF+y6Q/69L3chC2ubyhvCFsA9j56Qw9Ae+0nQEkqR9rAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/plus.png
// module id = cv9b
// module chunks = 216